// Velo API Reference: https://www.wix.com/velo/reference/api-overview/introduction

$w.onReady(function () {

	// Write your Javascript code here using the Velo framework API

	// Print hello world:
	// console.log("Hello world!");

	// Call functions on page elements, e.g.:
	// $w("#button1").label = "Click me!";

	// Click "Run", or Preview your site, to execute your code

});import { timeline } from 'wix-animations';

$w.onReady(function () {
    $w('#repeater').onItemReady(($item, itemData, index) => {
        $item('#image').onMouseIn((event) => {
            const zoomIn = { y: 4, x: 4, scale: 1.40, duration: 600, easing: 'easeOutCirc' };
            timeline()
                .add($item('#image'), zoomIn)
                .play()
        });

        $item('#image').onMouseOut((event) => {
            const reset = { y: 0, x: 0, scale: 1, duration: 600, easing: 'easeOutCirc' };
            timeline()
                .add($item('#image'), reset)
                .play()
        });

    });
});